module.exports = __webpack_public_path__ + "static/img/16052C_1_2_R_20200606_fit.b7c8dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16052C_1_2_R_20200606_fit.png
// module id = wh+1
// module chunks = 0